module.exports = __webpack_public_path__ + "img/logo.c486e774.svg";